
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","width":"96px","height":"96px"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3f51b5","d":"M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"}}),_c('path',{attrs:{"fill":"#fff","d":"M29.368,24H26v12h-5V24h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H30v4h-2.287 C26.104,16,26,16.6,26,17.723V20h4L29.368,24z"}})])
          )
        }
      }
    